import { basicPath } from '../basicPath';

// Helper function to get the correct API path prefix based on domain
const getLessonsPath = (endpoint) => {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const prefix = hostname.includes('readingplex') ? '/rp' : '/mp';
    if (!endpoint) return `${prefix}/lessons`;
    return `${prefix}/lessons/${endpoint}`;
};

export const fetchLessonsAll = (params) => async (dispatch) => {
    const path = getLessonsPath('all');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchLessonsId = (params) => async (dispatch) => {
    const path = getLessonsPath('id');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const createLesson = (params) => async (dispatch) => {
    const path = getLessonsPath('');
    const type = 'post';
    return await basicPath(dispatch, params, path, type);
}

export const updateLesson = (params) => async (dispatch) => {
    const path = getLessonsPath('');
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const deleteLesson = (params) => async (dispatch) => {
    const path = getLessonsPath('');
    const type = 'delete';
    return await basicPath(dispatch, params, path, type);
}